import React from 'react';

import { Spinner } from '../Spinner/Spinner';

export default function Loader() {
  return (
    <div className="bg-black absolute inset-0 bg-opacity-5 z-10 flex">
      <div className="m-auto ">
        <Spinner />
      </div>
    </div>
  );
}
